(function($, undefined) {
	
	'use strict';
	var favorites = null;
	
	var processFavorite = function() {
		var t = $(this);
		var artistId = t.attr('data-artistid');
		var researcherId = t.attr('data-researcherid');
		var gendataId = t.attr('data-gendataid');
		var textCtn = t.find('.favorite-btn-text');
		var addText = t.attr('data-add');
		var removeText = t.attr('data-remove');

		if (favorites === null) {
			favorites = t.attr('data-favorites');
		}

		if (!favorites.length) {
			favorites = artistId;
		} else {
			if (favorites.split(',').indexOf(artistId) !== - 1) {
				var newFavs = favorites.split(',');
				newFavs.splice(newFavs.indexOf(artistId), 1);

				favorites = newFavs.join();
			} else {
				favorites =  favorites + ',' + artistId;
			}
		}

		//console.log(favorites);

		updateFavorites(t, researcherId, gendataId, favorites, function(response) {
			if (response.indexOf('success') !== -1) {
				var btns = $('.toggle-favorite-btn[data-artistid=' + artistId + ']');

				if (t.hasClass('favorite-page')) {
					t.closest('.artist-demo').fadeOut(function() {
						$(this).remove();
					});
				} else {
					if (t.hasClass('add')) {
						btns.removeClass('add');
						if (btns.attr('title')) {
							btns.attr('title', removeText);
						}
						if (btns.find('.favorite-btn-text').length) {
							textCtn.html(removeText);
						}
					} else {
						btns.addClass('add');
						if (btns.attr('title')) {
							btns.attr('title', addText);
						}
						if (btns.find('.favorite-btn-text').length) {
							textCtn.html(addText);
						}
					}
				}

			}
		});
	};

	var updateFavorites = function (btn, researcherId, id, favorites, callback) {
		//console.log('favoritesid:' + id);
		var data = {
			field1: 'favorites',
			field2: favorites,
			field9: researcherId,
			ajax: true
		};

		if (id !== null) {
			data.id = id;
		}
		
		//console.log('favorites data:');
		//console.log(JSON.stringify(data));
		$.ajax({
			url: '/action/manageGenData',
			cache: false,
			data: data,
			method: 'POST',
			success: function (response) {
				//console.log('favorites new/edit : ' + response);

				if (btn.attr('data-gendataid').length === 0) {
					$('.toggle-favorite-btn').attr('data-gendataid', response.split('-')[1]);
				}
				
				if (typeof callback === 'function') {
					callback(response);
				}
			}
		});
	};

	var init = function () {
		$('body').on('click', '.toggle-favorite-btn', processFavorite);
	};
	
	$(window).ready(function () {
		init();
	});
	
})(jQuery);
